import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Header.css';

const Header = ({ onThemeToggle, isOnline = true }) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 24);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', closeOnEscape);

    return () => {
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, []);

  const navItemClass = ({ isActive }) =>
    `nav-link px-3 py-2 rounded-pill fw-semibold nav-link-custom ${isActive ? 'active' : ''}`;

  return (
    <header className={`header fixed-top ${scrolled ? 'header-scrolled' : ''}`}>
      <div className="container">
        <nav className="navbar navbar-expand-lg py-2 px-2 px-md-3 navbar-glass" aria-label="Main navigation">
          <Link to="/" className="navbar-brand d-flex align-items-center gap-2 fw-bold text-dark m-0">
            <span className="brand-mark d-inline-flex align-items-center justify-content-center rounded-circle">
              <i className="bi bi-code-slash"></i>
            </span>
            <span className="d-flex flex-column lh-1">
              <span className="fs-6">Muhibullah</span>
              <small className="text-secondary">Noorzad</small>
            </span>
          </Link>

          <button
            className="navbar-toggler border-0 shadow-none"
            type="button"
            aria-label="Toggle navigation"
            aria-expanded={isOpen}
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <i className="bi bi-list fs-3 text-dark"></i>
          </button>

          <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`}>
            <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-1">
              <li className="nav-item">
                <NavLink to="/" end className={navItemClass}>
                  Home
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/blog" className={navItemClass}>
                  Blog
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/projects" className={navItemClass}>
                  Portfolio
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/services" className={navItemClass}>
                  Services
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/about" className={navItemClass}>
                  About
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/profile" className={navItemClass}>
                  Profile
                </NavLink>
              </li>

              <li className="nav-item mt-2 mt-lg-0 ms-lg-2 d-flex align-items-center gap-2">
                <button
                  type="button"
                  className="btn btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center"
                  style={{ width: '38px', height: '38px' }}
                  onClick={onThemeToggle}
                  aria-label="Toggle theme"
                >
                  <i className="bi bi-moon-stars"></i>
                </button>

                <Link to="/contact" className="btn btn-primary rounded-pill px-4 fw-semibold">
                  Hire Me
                </Link>
              </li>
            </ul>

            <div className="d-lg-none mt-3 small text-muted border-top pt-3">
              <span className={`badge ${isOnline ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                {isOnline ? 'Online' : 'Offline'}
              </span>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
